<template>
	<div class="row">
		<div class="col-md-6 col-md-offset-3">
			<!-- error message -->
			<div class="alert alert-danger" v-if="errorMessage">
				<strong>{{ errorMessage }}</strong>
			</div>

			<!-- success message -->
			<div class="alert alert-success" v-if="successMessage">
				<strong>{{ successMessage }}</strong>
			</div>

			<div class="panel panel-custom">
				<div class="panel-heading">
					<i class="fa fa-lock pull-right" style="margin-top:5px;"></i>
					<strong class="text-uppercase">RECUPERAR SENHA</strong>
				</div>
				<div class="panel-body">
					<form @submit.prevent="preSave">
						<template v-if="form.idMunicipe && form.hash">
							<v-input
								label="ID DO MUNÍCIPE"
								v-model="form.idMunicipe"
								disabled
							></v-input>

							<v-textarea
								label="HASH"
								v-model="form.hash"
								rows="2"
								disabled
							></v-textarea>

							<v-input
								type="password"
								label="NOVA SENHA"
								v-model="form.senha"
								maxlength="20"
								:error-message="validating
									? form.senha.length < 5
										? 'Deve conter ao menos 5 caracteres'
										: form.senha !== form.novaSenha
											? 'As senhas não coincidem'
											: ''
									: ''
								"
							></v-input>

							<v-input
								type="password"
								label="REPITA A NOVA SENHA"
								v-model="form.novaSenha"
								maxlength="20"
								:error-message="validating
									? form.novaSenha.length < 5
										? 'Deve conter ao menos 5 caracteres'
										: form.senha !== form.novaSenha
											? 'As senhas não coincidem'
											: ''
									: ''
								"
							></v-input>
						</template>

						<template v-else>
							<v-input
								type="tel"
								label="INFORME O CPF USADO NO CADASTRO"
								v-model="form.cpf"
								:mask="{ format: '99999999999' }"
								:error-message="validate('isValidCPF', form.cpf, 'CPF inválido')"
							></v-input>

							<v-input
								label="INFORME O E-MAIL USADO NO CADASTRO"
								v-model="form.email"
								:error-message="validate('isValidEmail', form.email, 'E-mail inválido')"
							></v-input>
						</template>


						<template v-if="confirming">
							<form @submit.prevent="save" class="form-horizontal">
								<div class="form-group" style="margin-bottom:0;">
									<div class="col-xs-6">
										<label class="text-uppercase" style="line-height:35px;margin-bottom:0px">Confirma?</label>
									</div>
									<div class="col-xs-6 text-right">
										<button type="button" class="btn btn-danger" @click="confirming = false">NÃO</button>
										<button type="submit" class="btn btn-success">SIM</button>
									</div>
								</div>
							</form>
						</template>
						<template v-else>
							<button type="submit" class="btn btn-success pull-right">
								{{ form.idMunicipe && form.hash ? 'ALTERAR SENHA' : 'RECUPERAR SENHA' }}
							</button>
						</template>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import $ from 'jquery';
	import Form from 'helpers/form';
	import rules from 'helpers/validationRules';

	export default {
		data() {
			let idMunicipe = this.$route.query.idMunicipe;
			let hash = this.$route.query.hash;

			return {
				confirming: false,
				validating: false,
				errorMessage: '',
				successMessage: '',

				form: new Form({
					idMunicipe: idMunicipe,
					hash: hash,
					senha: '',
					novaSenha: '',
					cpf: '',
					email: ''
				})
			};
		},

		methods: {
			validate(rule, value, arg, message) {
				if (message === undefined) {
					message = arg;
				}

				if (this.validating) {
					return rules[rule](value, arg) ? '' : message;
				}
			},

			hasValidationErrors() {
				let fields = $('.has-error');

				return fields.length > 0;
			},

			preSave() {
				this.validating = true;
				this.errorMessage = '';

				this.$nextTick(() => {
					if (this.hasValidationErrors() === false) {
						this.confirming = true;
					} else {
						let firstErrorField = $('.has-error:first');

						window.scrollTo(0, firstErrorField.position().top);
					}
				});
			},

			save() {
				let url = `${Config.BASE_URL}/municipe/solicitarRecuperacaoSenha`;

				if (this.form.idMunicipe && this.form.hash) {
					url = `${Config.BASE_URL}/municipe/recuperarSenha`;
				}

				this.validating = false;
				this.confirming = false;

				this.form.save(url)
					.then(() => {
						if (this.form.idMunicipe && this.form.hash) {
							this.successMessage = 'Senha alterada com sucesso!';
						} else {
							this.successMessage = 'Foi enviado um e-mail com os procedimentos necessários para a recuperação da senha!';
						}

						this.form.clear();
					})
					.catch(error => {
						this.errorMessage = error.responseJSON.message || error.responseJSON.errorMessage;
					})
					.done(() => {
						window.scrollTo(0, 0);

						setTimeout(() => {
							this.successMessage = '';

							if (this.errorMessage) {
								this.errorMessage = '';
							} else {
								this.$router.push('/');
							}
						}, 10000);
					});
			}
		}
	};
</script>


// WEBPACK FOOTER //
// recuperarSenha.vue?2b770754